/* MAIDEN CRICKET · Size guide modal · assets/size-guide-drawer.js (v5) */
(function () {
  if (window.__maidenSizeGuide) return;
  window.__maidenSizeGuide = true;

  var lastFocus = null;
  var pageCache = {};
  var observer = null;

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[\u2012-\u2015]/g, '-')
      .replace(/[\u2018\u2019\u02bc`]/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  function toInches(text) {
    return String(text).replace(/\d+(\.\d+)?/g, function (n) {
      return (Math.round((parseFloat(n) / 2.54) * 10) / 10).toString();
    }).replace(/cm\b/gi, 'in');
  }

  function fetchPage(url) {
    if (!pageCache[url]) {
      pageCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    return pageCache[url];
  }

  function extractTables(doc) {
    var main = doc.querySelector('#MainContent') || doc.body;
    var byHeading = {};
    var order = [];
    main.querySelectorAll('table').forEach(function (table) {
      var heading = '';
      var el = table;
      while (el && el !== main && !heading) {
        var prev = el.previousElementSibling;
        while (prev) {
          if (/^H[2-4]$/.test(prev.tagName)) { heading = prev.textContent; break; }
          var inner = prev.querySelectorAll('h2, h3, h4');
          if (inner.length) { heading = inner[inner.length - 1].textContent; break; }
          prev = prev.previousElementSibling;
        }
        el = el.parentElement;
      }
      heading = heading.trim();
      var key = norm(heading) || ('table-' + order.length);
      if (!(key in byHeading)) order.push(key);
      byHeading[key] = { heading: heading, table: table };
    });
    return order.map(function (k) { return byHeading[k]; });
  }

  function tableSizes(table) {
    var head = table.querySelector('thead tr') || table.querySelector('tr');
    if (!head) return [];
    return Array.prototype.slice.call(head.children, 1).map(function (c) { return norm(c.textContent); });
  }

  function pickTables(all, sizes, part) {
    var wanted = sizes.map(norm).filter(Boolean);
    var matched = all.filter(function (t) {
      var cols = tableSizes(t.table);
      return wanted.some(function (s) { return cols.indexOf(s) !== -1; });
    });
    if (!matched.length) matched = all;
    if (part) {
      var key = part.slice(0, -1);
      var narrowed = matched.filter(function (t) { return norm(t.heading).indexOf(key) !== -1; });
      if (!narrowed.length) {
        narrowed = all.filter(function (t) { return norm(t.heading).indexOf(key) !== -1; });
      }
      if (narrowed.length) matched = narrowed;
    }
    return matched;
  }

  function buildTable(src) {
    var out = document.createElement('table');
    out.className = 'sgd__table';
    var rows = src.querySelectorAll('tr');
    var thead = document.createElement('thead');
    var tbody = document.createElement('tbody');
    rows.forEach(function (row, i) {
      var tr = document.createElement('tr');
      Array.prototype.forEach.call(row.children, function (cell, j) {
        var text = cell.textContent.trim();
        var isHead = i === 0 || j === 0;
        var c = document.createElement(isHead ? 'th' : 'td');
        if (i === 0) c.setAttribute('scope', 'col');
        else if (j === 0) c.setAttribute('scope', 'row');
        else c.setAttribute('data-cm', text);
        c.textContent = text;
        tr.appendChild(c);
      });
      (i === 0 ? thead : tbody).appendChild(tr);
    });
    out.appendChild(thead);
    out.appendChild(tbody);
    return out;
  }

  function render(modal) {
    var target = modal.querySelector('[data-sgd-tables]');
    if (target.dataset.loaded) return Promise.resolve();
    var src = modal.getAttribute('data-sgd-src');
    var sizes = (modal.getAttribute('data-sgd-sizes') || '').split('|');
    var part = modal.getAttribute('data-sgd-part');

    return fetchPage(src).then(function (doc) {
      target.innerHTML = '';
      var tables = pickTables(extractTables(doc), sizes, part);

      if (tables.length) {
        tables.forEach(function (t) {
          var wrap = document.createElement('div');
          wrap.className = 'sgd__block';
          if (t.heading) {
            var h = document.createElement('h3');
            h.className = 'sgd__subtitle';
            h.textContent = t.heading;
            wrap.appendChild(h);
          }
          var scroller = document.createElement('div');
          scroller.className = 'sgd__table-wrap';
          scroller.appendChild(buildTable(t.table));
          wrap.appendChild(scroller);
          target.appendChild(wrap);
        });
        var name = modal.querySelector('.sgd__chartname');
        if (name && tables.length === 1 && tables[0].heading) name.textContent = tables[0].heading;
      } else {
        modal.querySelector('.sgd__units').hidden = true;
        var main = doc.querySelector('#MainContent') || doc.body;
        main.querySelectorAll('img').forEach(function (img) {
          if (img.closest('header, footer, [class*="header"], [class*="footer"]')) return;
          var copy = document.createElement('img');
          copy.src = img.currentSrc || img.getAttribute('src');
          copy.alt = img.alt || '';
          copy.loading = 'lazy';
          copy.className = 'sgd__guide-img';
          target.appendChild(copy);
        });
        if (!target.children.length) {
          target.innerHTML = '<p>See the <a href="' + src + '">full size guide</a>.</p>';
        }
      }
      target.dataset.loaded = '1';
    }).catch(function () {
      target.innerHTML = '<p>Couldn\u2019t load the size guide. <a href="' + src + '">Open it here</a>.</p>';
    });
  }

  function setUnit(modal, unit) {
    modal.querySelectorAll('[data-sgd-unit]').forEach(function (b) {
      var on = b.getAttribute('data-sgd-unit') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    modal.querySelectorAll('td[data-cm]').forEach(function (td) {
      var cm = td.getAttribute('data-cm');
      td.textContent = unit === 'in' ? toInches(cm) : cm;
    });
    modal.querySelectorAll('th').forEach(function (th) {
      if (!th.dataset.label) th.dataset.label = th.textContent;
      th.textContent = unit === 'in' ? th.dataset.label.replace(/\(cm\)/i, '(in)') : th.dataset.label;
    });
    modal.dataset.unit = unit;
    try { localStorage.setItem('maidenSizeUnit', unit); } catch (e) {}
  }

  function savedUnit() {
    try { return localStorage.getItem('maidenSizeUnit') || 'cm'; } catch (e) { return 'cm'; }
  }

  function open(modal) {
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('sgd-lock');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      modal.querySelector('.sgd__panel').focus();
    });
    render(modal).then(function () { setUnit(modal, savedUnit()); });
  }

  function close(modal) {
    modal.classList.remove('is-open');
    document.body.classList.remove('sgd-lock');
    setTimeout(function () { modal.hidden = true; }, 260);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sgd-open]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var modal = document.getElementById(trigger.getAttribute('data-sgd-open'));
      if (modal) open(modal);
      return;
    }
    var closer = e.target.closest('[data-sgd-close]');
    if (closer) { close(closer.closest('[data-sgd]')); return; }
    var unitBtn = e.target.closest('[data-sgd-unit]');
    if (unitBtn) setUnit(unitBtn.closest('[data-sgd]'), unitBtn.getAttribute('data-sgd-unit'));
  }, true);

  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector('[data-sgd].is-open');
    if (!modal) return;
    if (e.key === 'Escape') { close(modal); return; }
    if (e.key === 'Tab') {
      var f = modal.querySelectorAll('button:not([hidden]), a[href], [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // ---------- Placing the link beside the real SIZE label ----------

  function isVisible(el) {
    if (el.closest('.visually-hidden, .sr-only, .screen-reader-text, [hidden], [aria-hidden="true"]')) return false;
    var cs = window.getComputedStyle(el);
    if (cs.position === 'absolute' && (cs.clip !== 'auto' || parseFloat(cs.width) <= 1)) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  function isLabelish(el) {
    if (el.closest('.sgd, .sgd-trigger, .sgd-legend-text')) return false;
    if (el.querySelector('input, button, select, label')) return false;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.length > 30) return false;
    return /^(select\s+|choose\s+)?size\b/i.test(text) && isVisible(el);
  }

  function findSizeLabel(scope, sizes) {
    var wanted = sizes.map(norm).filter(Boolean);
    if (wanted.length) {
      var inputs = scope.querySelectorAll('input, option');
      for (var i = 0; i < inputs.length; i++) {
        if (wanted.indexOf(norm(inputs[i].value)) === -1) continue;
        var group = inputs[i].closest('fieldset, .product-form__input, [class*="option"], [class*="variant-picker__"], [class*="swatch"]') || inputs[i].parentElement;
        var node = group;
        while (node && node !== scope) {
          var cands = node.querySelectorAll('legend, label, span, p, div, h2, h3, h4, h5');
          for (var j = 0; j < cands.length; j++) {
            if (isLabelish(cands[j])) return cands[j];
          }
          var prev = node.previousElementSibling;
          if (prev && isLabelish(prev)) return prev;
          node = node.parentElement;
        }
      }
    }
    var els = scope.querySelectorAll('legend, label, span, p, div, h2, h3, h4, h5');
    for (var k = 0; k < els.length; k++) {
      if (isLabelish(els[k])) return els[k];
    }
    return null;
  }

  function placeTriggers() {
    document.querySelectorAll('.sgd-trigger').forEach(function (btn) {
      var id = btn.getAttribute('data-sgd-open');

      // One modal per product, kept on <body> so nothing clips it
      var modals = document.querySelectorAll('[data-sgd][id="' + id + '"]');
      if (modals.length > 1) {
        modals.forEach(function (m) { if (m.parentNode === document.body) m.remove(); });
      }
      var modal = document.getElementById(id);
      if (!modal) return;
      if (modal.parentNode !== document.body) document.body.appendChild(modal);

      // Already placed beside the label: leave it alone
      if (btn.parentElement && btn.parentElement.classList.contains('sgd-legend-row')) return;

      var sizes = (modal.getAttribute('data-sgd-sizes') || '').split('|');
      var scope = btn.closest('form, section, .product, product-info') || document;
      var label = findSizeLabel(scope, sizes);
      if (!label || label.contains(btn)) return;

      if (!label.classList.contains('sgd-legend-row')) {
        var span = document.createElement('span');
        span.className = 'sgd-legend-text';
        while (label.firstChild) span.appendChild(label.firstChild);
        label.appendChild(span);
        label.classList.add('sgd-legend-row');
      }
      label.appendChild(btn);
    });
    // Ignore the page changes we just made ourselves
    if (observer) observer.takeRecords();
  }

  var timer = null;
  function schedulePlace() {
    clearTimeout(timer);
    timer = setTimeout(placeTriggers, 120);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeTriggers);
  else placeTriggers();
  window.addEventListener('load', schedulePlace);

  document.addEventListener('variant:change', schedulePlace);
  document.addEventListener('shopify:section:load', schedulePlace);
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects, variant-radios, .product-form__input, fieldset')) schedulePlace();
  });

  if (window.MutationObserver) {
    observer = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.closest && t.closest('.sgd, .sgd-legend-row')) continue;
        if (list[i].addedNodes.length) {
          // Only re-check when a trigger is sitting somewhere unplaced
          var loose = document.querySelector('.sgd-trigger:not(.sgd-legend-row > .sgd-trigger)');
          if (loose) schedulePlace();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('pointerover', function (e) {
    var t = e.target.closest && e.target.closest('[data-sgd-open]');
    if (!t) return;
    var m = document.getElementById(t.getAttribute('data-sgd-open'));
    if (m) fetchPage(m.getAttribute('data-sgd-src'));
  });
})();